import { defineComponent } from 'vue'
import { tv } from 'tailwind-variants'
import { GridRow } from '../grid'

type SeparatorProps = {
  label?: string
  variant?: string
  size?: string
}

const SeparatorClass = tv({
  slots: {
    base: 'w-full items-center',
    line: 'h-px w-full',
    label: 'px-8'
  },
  variants: {
    color: {
      blue: {
        base: 'w-full text-findex-500',
        line: 'bg-findex-500 w-full'
      },
      gray: {
        base: 'w-full text-gray-500',
        line: 'bg-gray-300 w-full'
      },
      white: {
        base: 'w-full text-white',
        line: 'bg-white w-full opacity-[0.33]'
      }
    },
    size: {
      s: {
        label: 'text-sm'
      },
      m: {
        label: 'text-md',
        line: 'h-px',
        base: 'h-4'
      },
      l: {
        label: 'text-lg'
      }
    }
  }
})

const Separator = defineComponent<SeparatorProps>({
  setup(props) {
    const { base, line, label } = SeparatorClass({
      color: props.variant as any,
      size: props.size as any
    })

    return () => {
      return (
        <GridRow class={base()} layout={props.label ? 'auto max-content auto' : 'auto'}>
          {props.label ? (
            <>
              <div class={line()} />
              <span class={label()}>{props.label}</span>
              <div class={line()} />
            </>
          ) : (
            <div class={line()} />
          )}
        </GridRow>
      )
    }
  }
})

//const Separator = defineComponent<SeparatorProps>({
//  setup(props) {
//    return () => {
//      return (
//        <div class="w-full flex flex-row items-center justify-center ">
//          {props.label && (
//            <div class="w-full flex flex-row items-center justify-center gap-6">
//              <div class={SeparatorClass({ color: props.variant as any })} />
//              <div
//                class={SeparatorClass({ size: props.size as any, textColor: props.variant as any })}
//              >
//                {props.label}
//              </div>
//              <div class={SeparatorClass({ color: props.variant as any })} />
//            </div>
//          )}
//          {!props.label && <div class={SeparatorClass({ color: props.variant as any })} />}
//        </div>
//      )
//    }
//  }
//})

// const Separator: FunctionalComponent<SeparatorProps> = (props: SeparatorProps) => {
//   return <div class="w-full h-[18px] pt-1 justify-center items-center gap-6 inline-flex">
//     <div class="grow shrink basis-0 h-px bg-blue-800"></div>
//     <div class="text-center text-blue-400 text-sm font-normal font-['Inter'] leading-[14px]">{ props.label || '' }</div>
//     <div class="grow shrink basis-0 h-px bg-blue-800"></div>
//   </div>;
// }
Separator.props = ['label', 'variant', 'size']
export default Separator
